import { observer, inject } from "mobx-react";
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import {
  GridColumn,
  GridContainer,
  GridRow,
  Loader,
  Toastr,
  Utils,
  Img,
} from "arv-reactcomponents";
import { MYORDERS_MESSAGES, Endpoints } from "npmlinks-constants";
import MyOrderGrid from "../MyOrderGrid";

const INFINITE_SCROLL_OFFSET = 500;

@inject("OrdersStore")
@observer
class MyOrderWrapper extends Component {
  static loader() {
    return (
      <div className="nw-bodyoverlay">
        <div className="nw-bodyoverlay-loadercontainer">
          <Loader />
        </div>
      </div>
    );
  }
  constructor() {
    super();
    this.intialLoad = true;
    this.scrollFlag = false;
    this.removeScrollListener = Utils.noop;
    this.fetchOrders = this.fetchOrders.bind(this);
    this.initInfiniteScroll = this.initInfiniteScroll.bind(this);
  }

  componentDidMount() {
    this.fetchOrders(0);
  }

  componentWillUnmount() {
    this.removeScrollListener();
  }

  get ordersList() {
    return this.props.OrdersStore.ordersList;
  }

  get loading() {
    return this.props.OrdersStore.loading;
  }

  fetchOrders(pageNo) {
    this.props.OrdersStore.getOrderHistory(pageNo)
      .then(res => {
        if (res.length > 0 && !this.scrollFlag) {
          this.intialLoad = false;
          this.scrollFlag = true;
          this.initInfiniteScroll();
        }
      })
      .catch(err => {
        this.intialLoad = false;
        Toastr.showToastr({
          className: "nwc-toastr-list-danger nw-toastr",
          message: MYORDERS_MESSAGES.ERROR_MSG,
          timeout: 3000,
        });
        console.log(err);
      });
  }

  initInfiniteScroll() {
    const infiniteScrollFn = () => {
      if (
        this.isMyOrdersScrollAtBottom() &&
        this.ordersList.currentPage < this.ordersList.totalPages &&
        !this.loading
      ) {
        this.fetchOrders(this.ordersList.currentPage);
      }
    };

    this.removeScrollListener = Utils.onElementScroll(
      window,
      infiniteScrollFn,
      { passive: true },
    );
  }

  isMyOrdersScrollAtBottom() {
    const windowScrollVals = Utils.windowScroll();
    const elementVals = Utils.getBoundClientRect(this.listRef);
    if (elementVals.bottom - INFINITE_SCROLL_OFFSET < windowScrollVals.bottom) {
      return true;
    }
    return false;
  }

  render() {
    return (
      <Fragment>
        {this.loading && this.intialLoad && MyOrderWrapper.loader()}
        {this.ordersList.orders.length > 0 ? (
          <div
            className="nw-order-wrapper"
            ref={context => {
              this.listRef = context;
            }}
          >
            <GridContainer className="nwc-grid-container-strict nw-order-container">
              <GridRow className="nw-order-content">
                {this.ordersList.orders.map((list, index) => (
                  <GridColumn
                    className={`nwc-grid-col-sm-6 nw-order-gridcol ${
                      index === this.ordersList.orders.length - 1
                        ? "nw-order-gridcollast"
                        : ""
                      }`}
                    key={list.orderId}
                  >
                    <MyOrderGrid.component data={list} index={index} />
                  </GridColumn>
                ))}
              </GridRow>
              <GridRow>
                <GridColumn className="nw-order-paginationloader">
                  {this.loading && <Loader />}
                </GridColumn>
              </GridRow>
            </GridContainer>
          </div>
        ) : (
            !this.loading && (
              <div className="nw-myorder-nonloggedin">
              <div className="nw-myorder-noorder">
                <Img
                  className="nw-myorder-noordersmiley"
                  src={Endpoints.sadSmileyImage}
                  alt="noOrders"
                />
                <div className="nw-myorder-noordertitle">OOPS!</div>
                <div className="nw-myorder-logintext">{MYORDERS_MESSAGES.NOORDER}</div>
              </div>
            </div>
            )
          )}
      </Fragment>
    );
  }
}

MyOrderWrapper.wrappedComponent.propTypes = {
  OrdersStore: PropTypes.shape({
    getOrderHistory: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    ordersList: PropTypes.shape({
      orders: PropTypes.shape({}).isRequired,
      currentPage: PropTypes.number.isRequired,
      totalPages: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("OrdersStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: MyOrderWrapper.wrappedComponent,
  component: MyOrderWrapper,
};

export default ProjectComponent;
